import {useSelector } from "react-redux";
import { IReduxAppState } from "../reducers";
export function usePaymentState(){
  const paymentDetails = useSelector((state: IReduxAppState) => state.payments.paymentDetails);
  const isError = useSelector((state: IReduxAppState) => state.payments.isError);
  const paymentURL = useSelector((state: IReduxAppState) => state.payments.paymentURL);
  const paymentStage = useSelector((state: IReduxAppState) => state.payments.paymentStage);

  return { paymentDetails,isError,paymentURL,paymentStage};
};

